import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { login as loginApi } from '../services/api';
import toast from 'react-hot-toast';



export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login, company } = useAuth();
  const navigate = useNavigate();

  const companyName = company?.name?.trim() || 'Attendance & Payroll System';
  const companyWebsite = company?.website?.trim() || '';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await loginApi(form);
      const { token, username, role, staffId } = res.data;
      login(token, { username, role, staffId });
      toast.success(`Welcome, ${username}!`);
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a237e 0%, #283593 50%, #1565c0 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Segoe UI', sans-serif"
    }}>
      <div style={{
        background: 'white', borderRadius: 16, padding: '48px 40px',
        width: '100%', maxWidth: 420, boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        {/* Logo / Badge */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 72, height: 72, borderRadius: '50%',
            background: 'linear-gradient(135deg, #1a237e, #1565c0)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px', fontSize: 32
          }}>🏛️</div>
          <h1 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: '#1a237e', letterSpacing: 0.3 }}>
            {companyName}
          </h1>
          <p style={{ margin: '6px 0 0', color: '#888', fontSize: 12 }}>
            Attendance & Payroll Management System
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, color: '#333', fontSize: 14 }}>
              Username / Email / Phone
            </label>
            <input
              type="text"
              value={form.username}
              onChange={e => setForm({ ...form, username: e.target.value })}
              placeholder="Enter username, email or phone"
              required
              style={{
                width: '100%', padding: '12px 14px', borderRadius: 8,
                border: '1.5px solid #ddd', fontSize: 15, outline: 'none',
                boxSizing: 'border-box', transition: 'border 0.2s'
              }}
              onFocus={e => e.target.style.borderColor = '#1a237e'}
              onBlur={e => e.target.style.borderColor = '#ddd'}
            />
          </div>

          <div style={{ marginBottom: 28 }}>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, color: '#333', fontSize: 14 }}>
              Password
            </label>
            <input
              type="password"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              placeholder="Enter password"
              required
              style={{
                width: '100%', padding: '12px 14px', borderRadius: 8,
                border: '1.5px solid #ddd', fontSize: 15, outline: 'none',
                boxSizing: 'border-box'
              }}
              onFocus={e => e.target.style.borderColor = '#1a237e'}
              onBlur={e => e.target.style.borderColor = '#ddd'}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '14px', borderRadius: 8,
              background: loading ? '#90a4ae' : 'linear-gradient(135deg, #1a237e, #1565c0)',
              color: 'white', fontWeight: 700, fontSize: 16,
              border: 'none', cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s'
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 24, color: '#999', fontSize: 12 }}>
          {companyWebsite || 'APMS'} • v2.0
        </p>
      </div>
    </div>
  );
}
